import {translations} from 'presentation/translations-new';

const {firstOptionTitle, secondOptionTitle, thirdOptionTitle} =
	translations['pt-br'].others.facialBiometric.documentPhoto.documentSelection;

const DOCUMENT_OPTIONS = [
	{
		title: firstOptionTitle,
		value: 'cnh',
	},
	{
		title: secondOptionTitle,
		value: 'rg',
	},
	{
		title: thirdOptionTitle,
		value: 'birthCertificate',
	},
];

export {DOCUMENT_OPTIONS};
